import React from 'react';
// components
import Modal from 'shared/modals/Modal';
import OrderSupportRequestComment from './SupportRequestDetailsPage/OrderSupportRequestComment'

const OrderSupportRequestLatestCommentModal = ({
  onClose,
  initialValues,
}) => {
  return (
    <Modal isOpen={true} handleClose={onClose} containerStyle='medium' title='Latest Comment'>
      <section>
         <OrderSupportRequestComment dataItem={initialValues}/>
      </section>
    </Modal>
  );
};

export default OrderSupportRequestLatestCommentModal;
